import { useMemo } from 'react'
import { SelectOption } from 'types/common'

const useRelativePickupableTimes = (): SelectOption[] => {
  return useMemo(() => {
    const _times: SelectOption[] = [{ label: '制限なし', value: '0' }]
    // 15分刻みで180分までのオプションを作る
    for (let i = 15; i <= 180; i = (i + 15) | 0) {
      _times.push({ label: `${i}分`, value: i.toString() })
    }
    return _times
  }, [])
}

export default useRelativePickupableTimes
